export default "__VITE_ASSET__Ebq4uudN__"